// extracted by mini-css-extract-plugin
module.exports = {"base":"column-m__base__2zyFb","ad-slot":"column-m__ad-slot__1ty2M"};